import React, { useState, useEffect, useRef} from "react";
import { useHistory } from "react-router-dom";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import TosSentPaymentListTableFilter from "../Filters/TosSentPaymentListTableFilter";
import TosCreateOrderForm from "../Forms/TosCreateOrderForm";
import config from "../../util/ApiforContext";
import moment from "moment";
import { odata } from "../Filters/Helper";

import { Table, Empty, Col, Row, Button, Modal,Tooltip,message,Tabs} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  RollbackOutlined,
  FileExcelOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";

const { TabPane } = Tabs;

const TosSentPayment = (props) => {
  const isInitialMount = useRef(true);
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tabKey,setTabKey] = useState(``);
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: `&$filter=statusId ne 1 and statusId ne 4`,
  });
  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: [],
  });
  const [createOrderModalVisible, setCreateOrderModalVisible] = useState(false);
  const history = useHistory();

  const [isHasDateFilter, setIsHasDateFilter] = useState(false);
  const [isLast7DaysFilterEnabled, setIsLast7DaysFilterEnabled] =
    useState(false);
  const [isLast1DayFilterEnabled, setIsLast1DayFilterEnabled] = useState(false);

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        if (
          !response.isHasDateFilter &&
          !response.isLast1DayFilterEnabled &&
          !response.isLast7DaysFilterEnabled
        ) {
          isInitialMount.current = false;
          getTableData();
        }

        setIsHasDateFilter(response.isHasDateFilter);
        setIsLast1DayFilterEnabled(response.isLast1DayFilterEnabled);
        setIsLast7DaysFilterEnabled(response.isLast7DaysFilterEnabled);
      }
    });
  };

 useEffect(() => {
    if (!isInitialMount.current) {
      getTableData();
    }
  }, [tableDataQueryOptions]);


    useEffect(() => {
      getTenantParameter();
    }, [])

useEffect(() => {
    dateFilter();
  }, [isHasDateFilter, isLast1DayFilterEnabled, isLast7DaysFilterEnabled]);


  const dateFilter = () => {
    let startDate;

    if (isLast1DayFilterEnabled) {
      startDate = moment(new Date()).add(-1, "days");
    } else if (isLast7DaysFilterEnabled) {
      startDate = moment(new Date()).add(-7, "days");
    } else if (isHasDateFilter) {
      startDate = moment(new Date()).add(-1, "months");
    }


    if (startDate) {
      const newDateFilter = odata.dateRange(
            "paymentDate",
            startDate,
            new Date()
          );

      setTableDataQueryOptions((prevState) => {
        return {
          ...prevState,
          skip: 0,
          current: 1,
          take: tableDataQueryOptions.take,
          values: {
            paymentDateMin: startDate,
            paymentDateMax: new Date(),
          },
          filter: prevState.filter
          ? `${prevState.filter} and ${newDateFilter}`
          : `&$filter=${newDateFilter}`,
        };
      });

      isInitialMount.current = false;
    }
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      `/Payment/ExportExcel`,
      {
        query: tableDataQueryOptions.filter,
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${config.apiUrl
          }/Payment/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const getTableData = () => {
    let { skip, take, filter } = tableDataQueryOptions;
    if (props.match.params.directiveId && !filter) {
      //ordernumber varsa ekrandan filtreyide kaldirabiliriz.
      filter = ``;
    }

    setTableData({
      ...tableData,
      loading: true,
    });
     RequestHandler.get(
       `/payment?$count=true${filter}&$skip=${skip}&$top=${take}`
     ).then((response) => {

         setTableData({
           data: response.value,
           total: response["@odata.count"],
           loading: false,
         });
     });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: buildTabFilter(tabKey),
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onTableSelectChange = (selectedKeys, selectedRecords) => {
    setSelectedRows({
      keys: selectedKeys,
      data: selectedRecords,
    });
  };

  const onClickCreateOrder = () => {
    setCreateOrderModalVisible(true);
  };
  const buildTabFilter = (key) => {
    if (key === 'swift') return '&$filter=isSwiftPayment eq true';
    if (key !== '0' && key !== '') return `&$filter= statusId eq ${key}`;
    return '&$filter=statusId ne 1 and statusId ne 4';
  };

  const callback = (key) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: buildTabFilter(key) };
    });
    setTabKey(key);
  }
  const columns = [
    {
      title: "Gönderen Banka",
      dataIndex: "sendBankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Alıcı Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Ad Soyad / Ünvan",
      align:'center',
      dataIndex: "title",
    },
    {
      title: "Alıcı Iban",
      align:'center',
      dataIndex: "iban",
    },
    {
      title: "Tutar",
      align:'right',
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      align:'center',
      dataIndex: "currencyCode",
      render: (data, row) => (
        data
      ),
    },
    {
      title: "Talimat Numarası",
      align:'center',
      dataIndex: "referanceNumber",
    },
    {
      title: "Ödeme Durumu",
      align:'center',
      dataIndex: "status",
      render: (data, row) => (
        <span>
          {data}
          {row.isPaidFromAccountTransaction && (
            <Tooltip title="Hesap hareketinden eşleme ile ödendi">
              <InfoCircleOutlined style={{ color: '#1890ff', marginLeft: 5 }} />
            </Tooltip>
          )}
        </span>
      ),
    },
    {
      title: "Durum Mesajı",
      align:'center',
      dataIndex: "statusMessage",
    },
    {
      title: "Ödeme Tarihi",
      align:'center',
      dataIndex: "paymentDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
  ];

  const swiftColumns = [
    {
      title: "Gönderen Banka",
      dataIndex: "sendBankLogo",
      width: "8%",
      render: (text) => <img src={text} alt="" />,
    },
    { title: "Ad Soyad / Ünvan", align: "center", dataIndex: "title" },
    { title: "Alacaklı Banka Adı", align: "center", dataIndex: "swiftBankName" },
    { title: "Swift Kod", align: "center", dataIndex: "swiftCode" },
    { title: "Alıcı Iban", align: "center", dataIndex: "iban" },
    {
      title: "Tutar",
      align: "right",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    { title: "Para Birimi", align: "center", dataIndex: "currencyCode" },
    { title: "Masraf", align: "center", dataIndex: "swiftChargeTypeName" },
    {
      title: "İşlem Detayı",
      align: "center",
      dataIndex: "swiftTransactionDetailName",
    },
    { title: "Fatura No", align: "center", dataIndex: "invoiceNumber" },
    { title: "Ödeme Durumu", align: "center", dataIndex: "status" },
    {
      title: "Ödeme Tarihi",
      align: "center",
      dataIndex: "paymentDate",
      render: (data) => moment(data).format("DD.MM.YYYY"),
    },
    { title: "Açıklama", dataIndex: "description" },
  ];

  return (
    <>
      {props.match.params.directiveId && (
        <Row style={{ marginBottom: 9 }}>
          <Col flex={1}>
            <a
              onClick={() => history.goBack()}
              style={{ color: "black", marginLeft: "4%" }}
            >
              {" "}
              <RollbackOutlined /> GERİ DÖN
            </a>
          </Col>
          <Col flex={4}></Col>
        </Row>
      )}
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> GÖNDERİLMİŞ ÖDEMELER
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
            <Tooltip title="Excel İndir">
              <a
                style={{
                  color: "green",
                  fontSize: "180%",
                  marginRight: 30,
                }}
                onClick={onClickExportExcel}
              >
                <FileExcelOutlined />
              </a>
            </Tooltip>
          {selectedRows.keys.length > 0 && (
            <Button onClick={onClickCreateOrder} style={{ marginBottom: 0 }}>
              <SendOutlined /> Talimat Oluştur
            </Button>
          )}
        </Col>
      </Row>

      <TosSentPaymentListTableFilter
        filter={tableDataQueryOptions.filter}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        data={tableDataQueryOptions.values}
        extraText={
        isHasDateFilter
          ? "Varsayılan olarak son 1 aylık veri listelenmektedir."
          : isLast1DayFilterEnabled
          ? "Varsayılan olarak son 1 günlük veri listelenmektedir."
          : isLast7DaysFilterEnabled
          ? "Varsayılan olarak son 7 günlük veri listelenmektedir."
          : ""
      }
      />

      <Tabs defaultActiveKey="0" onChange={callback} destroyInactiveTabPane>
        <TabPane tab="Tümü" key="0" />
        <TabPane tab="Ödendi" key="9" />
        <TabPane tab="Hatalı" key="3" />
        <TabPane tab="Swift Ödemeler" key="swift" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              showSizeChanger: true,
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>


      <Modal
        id="createOrderModal"
        centered
        visible={createOrderModalVisible}
        onOk={() => setCreateOrderModalVisible(false)}
        onCancel={() => setCreateOrderModalVisible(false)}
        width={800}
        footer={null}
      >
        <TosCreateOrderForm
          reCreateMode
          selectedPayments={selectedRows.data}
          data={{ paymentIds: selectedRows.keys }}
        />
      </Modal>
    </>
  );
};

export default TosSentPayment;
